import React, { Component } from 'react';
import classnames from 'classnames';
import { withStyles } from 'tss-react/mui';
import Fab from '@mui/material/Fab';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Delete } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import {
  data as docTypes,
  DAFAC,
  DBANQ,
  DRCPRO,
  DINTERRIB,
} from '@lba-dev/package.local-globals/docTypes';
import { fromJS } from 'immutable';

import DropboxUpload from '../DropboxUpload';
import DocsList from '../List/DocsList';
import api from '../../api';
import notifSystem from '../../notifSystem';
import { checkDocument } from '../../utils/function';
import NoAssurance from '../NoAssurance';

const styles = {
  flexBox: { display: 'flex', justifyContent: 'space-between' },
  fullWidth: { width: '100%' },
  leftMargin: { marginBottom: 20 },
  icon: { margin: 10 },
};

const defaultKeys =
  docTypes.filter(
    (e) => e.type === 'document' && ![DAFAC, DBANQ, DINTERRIB].includes(e._id)
  ) || [];

const defaultState = () => ({
  deleteCounter: 0,
});

class Documents extends Component {
  state = this.props.keys.reduce((a, v) => {
    a[v.key] = [];
    a[`${v.key}Checked`] = [];
    return a;
  }, defaultState());

  componentDidMount() {
    if (this.props.dropbox) {
      this.updateState(this.props.dropbox);
    }
  }

  updateState = (data, del = false) => {
    const initKeys = del
      ? this.props.keys.reduce((b, k) => {
        b[k.key] = [];
        b[`${k.key}Checked`] = [];
        return b;
      }, {})
      : {};
    this.setState(
      data.reduce(
        (a, v) => {
          const item =
            this.props.keys.find((e) => e._id === v.get('type')) || {};
          a[item.key] = [...(a[item.key] || []), v.toJS()];
          return a;
        },
        {
          dropbox: data,
          ...initKeys,
          ...defaultState(),
        }
      )
    );
  };

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.getFiles();
    }
  }

  getFiles = async () => {
    const res = await api.artisans.get(this.props.id, {
      field: JSON.stringify({ dropbox: 1 }),
    });
    const dropbox = ((res.body() || {}).data() || {}).dropbox
      ? fromJS(res.body().data().dropbox)
      : this.props.dropbox;
    if (dropbox) {
      this.updateState(dropbox, this.props.keys);
    }
  };

  getFile = (id, element) => {
    const setData = this.props.setData;
    const dropbox = this.state.dropbox.push(fromJS(element));
    if (setData) {
      setData(['dropbox'], dropbox);
    }
    this.updateState(dropbox, true);
  }

  updateFiles = (newFiles) => {
    const setData = this.props.setData;
    api.artisans
      .patch(this.props.underscoreId, {
        dropbox: newFiles,
      })
      .then((res) => res.body().data())
      .then(({ dropbox }) => {
        if (setData) {
          setData(['dropbox'], fromJS(dropbox));
        }
        this.updateState(fromJS(dropbox), true);
      })
      .catch((e) => notifSystem.error('Erreur', e.message || e));
  };

  deleteCheckTab = () => {
    const { keys } = this.props;
    const { dropbox } = this.state;
    let newFiles = dropbox.toJS();
    keys.map((k) => {
      const checked = this.state[`${k.key}Checked`];
      if (checked.length && newFiles.length) {
        newFiles = newFiles.filter((e) => !checked.includes(e.fileName));
      }
    });
    this.updateFiles(newFiles);
  };

  handleToggle = (key) => (v) => {
    const keyChecked = `${key}Checked`;
    const { [keyChecked]: prevArr, deleteCounter } = this.state;
    const nextArr = this.state[keyChecked].toggleValue(v.fileName);
    this.setState({
      [keyChecked]: nextArr,
      deleteCounter: deleteCounter + (nextArr.length > prevArr.length ? 1 : -1),
    });
  };

  generateList = (k) => {
    const {
      id,
      underscoreId,
      setData,
      classes,
      supp: { noAssurance },
      users
    } = this.props;
    const { [`${k.key}Checked`]: checked, [k.key]: files } = this.state;
    return (
      <Accordion>
        <AccordionSummary>
          <div className={classnames(classes.flexBox, classes.fullWidth)}>
            <Typography variant="body1" children={k.name} />
            <div className={classes.flexBox}>
              {k._id === DRCPRO && (
                <NoAssurance
                  artisan={{ noAssurance, _id: underscoreId }}
                  setData={() => setData(['noAssurance'], !noAssurance)}
                />
              )}
              {!!setData && (
                <DropboxUpload
                  id={id}
                  color={checkDocument({ type: k._id }, this.props.supp)}
                  length={files.length + 1}
                  type={k._id}
                  underscoreId={underscoreId}
                  getFile={this.getFile}
                  path="artisans"
                />
              )}
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <DocsList
            isSelected={(e) => checked.includes(e.fileName)}
            handleDelete={this.handleToggle(k.key)}
            id={this.props.id}
            data={files}
            getFile={this.getFiles}
            users={users}
          />
        </AccordionDetails>
      </Accordion>
    );
  };

  render() {
    const { setData, displayTitle, classes, keys } = this.props;
    const { deleteCounter } = this.state;
    return (
      <Card className="cards">
        <CardContent>
          <div className={classnames(classes.flexBox, classes.bottomMargin)}>
            {displayTitle && <Typography variant="h5" children="Documents" />}
            {!!setData && (
              <Fab
                size="small"
                className={classes.icon}
                disabled={!deleteCounter}
                onClick={this.deleteCheckTab}
                color="secondary"
                children={<Delete />}
              />
            )}
          </div>
          {keys.map(this.generateList)}
        </CardContent>
      </Card>
    );
  }
}

Documents.defaultProps = {
  keys: defaultKeys,
  displayTitle: true,
};

export default withStyles(Documents, styles);
